export enum WalletStatus {
    Inactive = 0,
    Active = 1,
    TemporaryBlocked = 2,
    PermanentBlocked = 3,
    Dormant = 4,
    ComplianceBlocked = 6,
    BlackList = 7
}


// WEBPACK FOOTER //
// ./src/model/types/wallet-status.ts